import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { Service } from "../services";
import { LoadingScreenService } from "../services/loading-screen/loading-screen.service";
import { GlobalService } from "../global.service";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material";
import { ChatComponent } from "../chat/chat.component";
import { AngularFireAnalytics } from "@angular/fire/analytics";
import { MessageService } from "../message.service";

@Component({
  selector: "app-changeplan",
  templateUrl: "./changeplan.component.html",
  styleUrls: ["./changeplan.component.sass"],
})
export class ChangeplanComponent implements OnInit {
  public currentList;
  public paymentData;
  public paymentscreen = 0;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public expand = [];
  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public info = [];
  public accounInfo: any;
  public selTab: number;
  public cycleDateField;
  public tabActive = "Mis Equipos y Servicios";
  public selectBan;
  public banlist;
  public subscribernumber;
  public offers: Array<any>;
  public data = [];
  public row = [];
  public changePlan;
  public commitmentOriginalMonths = 0;
  public planActual = "";
  public rectaActual;
  public planToChange = "";
  public currentSoc = "";
  public nextSoc = "";
  public subscriberNumber = "";
  public accountSubType;
  public accountType;
  public pricePlan;
  public amount;
  public ivuState;
  public tax;
  public totalPagar;
  public textoMovil = false;
  public screenView;
  public cycleEndDate;
  public nextDate;
  public screenActual = 1;
  public currentPlan;
  public actualPrice;
  public descriptions = "";
  //TODO nro number?
  public nroOrder = false;
  //TODO number order?
  public errorRecharging = false;
  public numberOrder = "";
  public numberOrder2 = "";
  public id;
  validatePaymentSuccess: boolean;
  resultDate: any;
  // paymentReceived: Subscription;
  public tabSelected = 1;
  @ViewChild(ChatComponent, { static: false }) sendChat: ChatComponent;
  @ViewChild("main") main: ElementRef;
  postpaidAccounts: any;
  prepaidAccounts: any;
  fixedAccounts: any;
  currentAccountType: any;
  initInfoIsComplete = false;
  constructor(
    public AngularFireAnalytics: AngularFireAnalytics,
    private router: Router,
    public appComponent: AppComponent,
    private loadingScreenService: LoadingScreenService,
    private services: Service,
    public global: GlobalService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private messageService: MessageService
  ) {
    this.AngularFireAnalytics.setCurrentScreen("Cambio de Plan");
    this.AngularFireAnalytics.logEvent("Cambio de Plan-Screenview");
    setTimeout(() => {
      console.log(
        "Alto-->" + (Number(this.main.nativeElement.offsetHeight) + 20)
      );
      console.log("Ancho-->" + Number(this.main.nativeElement.offsetWidth));
      this.messageService.sentIframeDimensions(
        (Number(this.main.nativeElement.offsetHeight) + 40).toString(),
        Number(this.main.nativeElement.offsetWidth).toString()
      );
    }, 500);
  }

  ngOnInit() {
    this.loadingScreenService.stopLoading();
    if (sessionStorage.getItem("isIframe")) {
      this.global.isIframe = true;
    }
    if (this.global.sessionReview() == true) {
      this.getInfo();
    }
  }

  getInfo() {
    if (this.global.isIframe) {
      const allInfo: [] = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).SubscriberInfo;

      allInfo.forEach((element: any, index) => {
        if (
          element.subscriberNumberField ==
          JSON.parse(sessionStorage.getItem("userdataIframe")).currentSuscriber
        ) {
          this.info.push(element);
        }
      });
    } else {
      this.info = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).SubscriberInfo;
    }

    this.validateInfo(0);
  }

  validateInfo(count: number) {
    if (count < 3) {
      setTimeout(() => {
        if (this.info.length === 0) {
          this.validateInfo(count + 1);
        } else {
          this.getMoreInfo();
        }
      }, 500);
    } else {
      this.messageService.sentMessage("canceled", {
        method: "Suscriptor no encontrado",
      });
      this.global.notif("Suscriptor no encontrado");
      this.global.signOff();
      this.loadingScreenService.stopLoading();
    }
  }

  getMoreInfo() {
    this.expand[0] = true;
    this.selTab = 1;
    this.getId();
    this.offers = [];
    this.banlist = null; //JSON.parse(atob(sessionStorage.getItem("AccountList")));
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    if (
      atob(sessionStorage.getItem("selectBan")) ==
      JSON.parse(sessionStorage.getItem("userdataIframe")).selectBan
    ) {
      console.log("ban confirmado");
      this.accounInfo = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).AccounInfo;
      this.cycleDateField = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).AccounInfo.cycleDateField;
      this.subscribernumber = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).SubscriberInfo.subscriberNumberField;
      this.global.mask(this.subscribernumber);
      this.cycleEndDate = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).AccounInfo.cycleEndDate;
      this.loadObserver = this.global.loadObserver.subscribe(
        (value: number) => {
          this.dataLoading(value);
        }
      );

      this.checkAccounts();
    } else {
      this.messageService.sentMessage("canceled", {
        method: "La cuenta no coincide con la sessión",
      });
      this.global.notif("La cuenta no coincide con la sessión");
      this.global.signOff();
      this.loadingScreenService.stopLoading();
    }
  }

  checkAccounts() {
    this.postpago = false;
    this.prepago = false;
    this.telefoniaFijo = false;
    this.type = sessionStorage.getItem("tab");
    this.postpaidAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "postpago"
    );
    this.prepaidAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "prepago"
    );
    this.fixedAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "telefoniaFijo"
    );
    this.totalAccountList = 0;
    this.type = sessionStorage.getItem("tab");
    sessionStorage.setItem("currentBan", sessionStorage.getItem("selectBan"));
    sessionStorage.setItem(
      "currentSuscriber",
      btoa(this.global.getSuscriberByDefault(this.selectBan))
    );
    this.postpaidAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "postpago"
    );
    this.prepaidAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "prepago"
    );
    this.fixedAccounts = this.global.fiterAccountBy(
      JSON.parse(atob(sessionStorage.getItem("AccountList"))),
      "telefoniaFijo"
    );
    this.totalAccountList = 0;
    //calculo de tipo de cuenta
    for (let i = 0; i < this.postpaidAccounts.length; i++) {
      if (this.postpaidAccounts[i].account == this.selectBan) {
        this.currentAccountType = "postpaid";
      }
    }
    for (let i = 0; i < this.prepaidAccounts.length; i++) {
      if (this.prepaidAccounts[i].account == this.selectBan) {
        this.currentAccountType = "prepaid";
      }
    }
    for (let i = 0; i < this.fixedAccounts.length; i++) {
      if (this.fixedAccounts[i].account == this.selectBan) {
        this.currentAccountType = "fixed";
      }
    }

    //fin calculo de tupo de cuenta
    if (
      this.postpaidAccounts != "" &&
      (this.type == "postpago" || this.type == null) &&
      this.currentAccountType == "postpaid"
    ) {
      this.currentList = this.postpaidAccounts;
      this.postpago = true;
      this.totalAccountList = this.postpaidAccounts.length;
      sessionStorage.setItem("currentPostpaid", btoa(this.selectBan));
      sessionStorage.setItem("tab", "postpago");
    } else if (
      this.prepaidAccounts != "" &&
      (this.type == "prepago" || this.type == null) &&
      this.currentAccountType == "prepaid"
    ) {
      this.prepago = true;
      this.currentList = this.prepaidAccounts;
      this.totalAccountList = this.prepaidAccounts.length;
      sessionStorage.setItem("currentPrepaid", btoa(this.selectBan));
      sessionStorage.setItem("tab", "prepago");
    } else if (
      this.fixedAccounts != "" &&
      (this.type == "telefoniaFijo" || this.type == null) &&
      this.currentAccountType == "fixed"
    ) {
      this.telefoniaFijo = true;
      this.currentList = this.fixedAccounts;
      this.totalAccountList = this.fixedAccounts.length;
      sessionStorage.setItem("currentFixed", btoa(this.selectBan));
      sessionStorage.setItem("tab", "telefoniaFijo");
    }
    this.initInfoIsComplete = true;
  }

  ngAfterViewInit() {
    this.validate();
  }

  validate() {
    setTimeout(() => {
      this.loadingScreenService.startLoading();
      if (this.initInfoIsComplete) {
        this.getOffers(this.info, 0);
      } else {
        this.validate();
      }
    }, 1000);
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
    this.loadingScreenService.startLoading();
    if (this.postpago == true) {
      this.type = "postpaid";
    } else if (this.prepago == true) {
      this.type = "prepaid";
    } else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.info = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo;
    this.accounInfo = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).AccounInfo;
    this.expand[0] = true;
    this.selTab = 1;
    this.getId();
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.offers = [];
    this.getOffers(this.info, 0);
  }
  updateExpand(index) {
    this.expand[index] = !this.expand[index];
  }
  statusChange(sw) {
    this.global.validateSession();
    this.selTab = sw;
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      if (id == "1") {
        this.selTab = 1;
      } else if (id == "2") {
        this.selTab = 2;
      } else {
        this.selTab = 1;
        this.router.navigate(["usage"]);
      }
    }
  }

  loadOffers(offers) {
    let ofertas = '{"offers":[';
    for (let i = 0; i < offers.length; i++) {
      if (i > 0) {
        ofertas += ",";
      }
      ofertas += '{"offers":[' + JSON.stringify(offers[i]) + "]}";
    }
    ofertas += "]}";
    this.offers = JSON.parse(ofertas);
    this.loadingScreenService.stopLoading();
  }

  offersData(data, type, row) {
    let offers = "";
    if (data != undefined) {
      if (
        data.object !== null ||
        data.DSLCatalogItems !== null ||
        data.socList !== null
      ) {
        if (
          type === "G" &&
          (this.postpago == true || this.telefoniaFijo == true)
        ) {
          if (data.object.length === 0) {
            return (
              '{"hasError":' +
              data.hasError +
              ',"ErrorDesc":"' +
              data.response +
              '","offersData":[]}'
            );
          }
        } else if (
          type !== "G" &&
          (this.postpago == true || this.telefoniaFijo == true)
        ) {
          if (data.DSLCatalogItems.length === 0) {
            return (
              '{"hasError":' +
              data.HasError +
              ',"ErrorDesc":"' +
              data.ErrorDesc +
              '","offersData":[]}'
            );
          }
        } else if (this.prepago == true) {
          let errorS = false;
          if (data.socList.length === 0) {
            if (data.success === false) {
              errorS = true;
            }
            return (
              '{"hasError":' +
              errorS +
              ',"ErrorDesc":"' +
              data.error +
              '","offersData":[]}'
            );
          }
        }

        var count = 0;
        offers = '{"hasError":false,"ErrorDesc":"","offersData":[';
        var contador = 0;
        var typePlan = "";
        // var description = '';
        var soc = "";
        var n = 0;
        var j = 0;
        if (
          type === "G" &&
          (this.postpago == true || this.telefoniaFijo == true)
        ) {
          if (data.object.length >= row) {
            count = Math.ceil(data.object.length / row);
          } else {
            count = 1;
          }
        } else if (
          type !== "G" &&
          (this.postpago == true || this.telefoniaFijo == true)
        ) {
          if (data.DSLCatalogItems.length >= row) {
            count = Math.ceil(data.DSLCatalogItems.length / row);
          } else {
            count = 1;
          }
        } else if (this.prepago == true) {
          if (data.socList.length >= row) {
            count = Math.ceil(data.socList.length / row);
          } else {
            count = 1;
          }
        }

        for (var i = 0; i < count; i++) {
          if (i > 0) {
            offers += ",";
          }
          var descriptions = "";
          offers += '{"offers":[';
          if (
            type === "G" &&
            (this.postpago == true || this.telefoniaFijo == true)
          ) {
            for (j = contador; j < contador + row; j++) {
              if (data.object[j] !== undefined) {
                if (j > contador) {
                  offers += ",";
                }

                typePlan = data.object[j].description.split(":");
                let description = String(typePlan[1]).split("-");
                if (description[0] === "undefined") {
                  description = [];
                }
                descriptions = "";
                descriptions += '{"descriptions":[';
                for (n = 0; n < description.length; n++) {
                  if (n > 0) {
                    descriptions += ",";
                  }
                  descriptions += '{"description":"' + description[n] + '"}';
                }
                descriptions += "]}";
                offers +=
                  '{"id":"0","typePlan":"' +
                  typePlan[0] +
                  '","descriptions":' +
                  descriptions +
                  ',"rent":"' +
                  parseFloat(data.object[j].rent).toFixed(2) +
                  '","soc":"' +
                  data.object[j].soc +
                  '","customerSubtype":"' +
                  data.object[j].customerSubtype +
                  '","customerType":"' +
                  data.object[j].customerType +
                  '"}';
              }
            }
          } else if (
            type !== "G" &&
            (this.postpago == true || this.telefoniaFijo == true)
          ) {
            for (j = contador; j < contador + row; j++) {
              if (data.DSLCatalogItems[j] !== undefined) {
                if (j > contador) {
                  offers += ",";
                }

                let description = String(
                  data.DSLCatalogItems[j].DESCRIPTION
                ).split(".");
                if (description === null) {
                  description = [];
                }

                descriptions = "";
                descriptions += '{"descriptions":[';
                for (n = 0; n < description.length; n++) {
                  if (description[n] !== "") {
                    if (n > 0) {
                      descriptions += ",";
                    }
                    descriptions += '{"description":"' + description[n] + '"}';
                  }
                }
                descriptions += "]}";
                offers +=
                  '{"id":"0","typePlan":"' +
                  data.DSLCatalogItems[j].PRODUCT_NAME +
                  '","descriptions":' +
                  descriptions +
                  ',"rent":"' +
                  parseFloat(data.DSLCatalogItems[j].PRICE).toFixed(2) +
                  '","soc":"' +
                  data.DSLCatalogItems[j].ADA_PRODUCT_ID +
                  '","customerSubtype":"","customerType":""}';
              }
            }
          } else if (this.prepago == true) {
            for (j = contador; j < contador + row; j++) {
              if (data.socList[j] !== undefined) {
                if (j > contador) {
                  offers += ",";
                }

                let description = data.socList[j].socDescription;
                if (description === null) {
                  description = [];
                }
                descriptions = "";
                descriptions += '{"descriptions":[';

                //descriptions += '{"description":"' + data.socList[j].socDescription + '"}';
                descriptions +=
                  '{"description":"' + data.socList[j].socDescription + '"}';

                descriptions += "]}";
                soc = data.socList[j].soc.replace("\t", "");
                offers +=
                  '{"id":"' +
                  data.socList[j].id +
                  '","typePlan":"' +
                  data.socList[j].description +
                  '","descriptions":' +
                  descriptions +
                  ',"rent":"' +
                  parseFloat(data.socList[j].rent).toFixed(2) +
                  '","soc":"' +
                  soc +
                  '","customerSubtype":"' +
                  data.socList[j].customerSubtype +
                  '","customerType":"' +
                  data.socList[j].customerType +
                  '"}';
              }
            }
          }
          contador = contador + 3;
          offers += "]}";
        }
        offers += "]}";
      } else {
        offers = '{"hasError":false,"ErrorDesc":"","offersData":[]}';
      }
    } else {
      offers = '{"hasError":false,"ErrorDesc":"","offersData":[]}';
    }
    return offers;
  }

  getOffers(subscriber, index) {
    this.loadingScreenService.startLoading();
    var type = subscriber[index].productTypeField;
    if (type == "G" && (this.postpago == true || this.telefoniaFijo == true)) {
      this.services
        .getChangeMobilePlan(
          this.token,
          this.accounInfo["creditClassField"],
          subscriber[index].planInfoField.sOCInfoField,
          parseFloat(subscriber[index].planInfoField.socRateField).toFixed(2),
          "LTE",
          this.accounInfo["accountTypeField"],
          this.accounInfo["accountSubtypeField"]
        )
        .subscribe(
          (data) => {
            this.loadingScreenService.stopLoading();
            if (data) {
              if (data.hasError == false) {
                if (parseInt(subscriber.length) - 1 === index) {
                  this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                  this.loadOffers(this.offers);
                } else {
                  this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                  this.getOffers(subscriber, parseInt(index + 1));
                }
              } else {
                if (parseInt(subscriber.length) - 1 === index) {
                  this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                  this.loadOffers(this.offers);
                } else {
                  this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                  this.getOffers(subscriber, parseInt(index + 1));
                }
                if (data.hasError == true) {
                  // this.loadingScreenService.stopLoading();
                }
              }
            } else {
              this.messageService.sentMessage("canceled", {
                method: "Error obteniendo planes",
              });
              this.global.notif(
                "Ha ocurrido un error obteniendo la data de los planes, por favor intente luego"
              );
            }
          },
          (error) => {
            this.loadingScreenService.stopLoading();
          }
        );
    } else if (
      type != "G" &&
      (this.postpago == true || this.telefoniaFijo == true)
    ) {
      //Planes para fijos
      this.services
        .getChangeFixedPlan(this.token, subscriber[index].subscriberNumberField)
        .subscribe(
          (data) => {
            if (parseInt(subscriber.length) - 1 === index) {
              this.offers.push(JSON.parse(this.offersData(data, type, 3)));
              this.loadOffers(this.offers);
            } else {
              this.offers.push(JSON.parse(this.offersData(data, type, 3)));
              this.getOffers(subscriber, parseInt(index + 1));
            }
            if (data.HasError === true) {
              this.loadingScreenService.stopLoading();
              this.messageService.sentMessage("canceled", {
                method: "Error obteniendo planes",
              });
            }
          },
          (error) => {
            this.loadingScreenService.stopLoading();
            this.messageService.sentMessage("canceled", {
              method: "Error obteniendo planes",
            });
          }
        );
    } else if (this.prepago == true) {
      this.services
        .getChangePlanPrepaid(
          this.accounInfo["creditClassField"],
          this.accounInfo["accountTypeField"],
          this.accounInfo["accountSubtypeField"],
          this.info[index].planInfoField.socRateField,
          "LTE",
          this.info[index].planInfoField.sOCInfoField,
          type,
          this.token
        )
        .subscribe(
          (data) => {
            if (!data.hasError) {
              var objFiltro = [];
              // var contK = 0;
              for (var k = 0; k < data.socList.length; k++) {
                //for (var k = 0; k < 1; k++) {
                if (
                  parseFloat(data.socList[k].rent) >=
                  parseFloat(subscriber[index].planInfoField.socRateField)
                ) {
                  objFiltro.push(data.socList[k]);
                  // if (contK > 0) {
                  //   objFiltro += ',';
                  // }
                  // objFiltro += '{"soc":"' + data.socList[k].soc + '","price":"' + data.socList[k].rent + '","description":"' + data.socList[k].socDescription + '","accountType":"' + data.socList[k].customerType + '","accountSubType":"' + data.socList[k].customerSubtype + '"}';
                  // contK++;
                }
              }
              // objFiltro += ']';
              // var objFiltro2 = JSON.parse(objFiltro);
              data.socList = objFiltro;
              if (parseInt(subscriber.length) - 1 === index) {
                this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                this.loadOffers(this.offers);
              } else {
                this.offers.push(JSON.parse(this.offersData(data, type, 3)));
                this.getOffers(subscriber, parseInt(index + 1));
              }
              if (data.hasError === true) {
                this.loadingScreenService.stopLoading();
              }
            } else {
              this.loadingScreenService.stopLoading();
              this.global.notif(
                "Actualmente esta función esta bajo mantenimiento por favor intente más tarde."
              );
              this.router.navigate(["/home"]);

              // if(data.hasError){
              //   this.global.notif("Estimado usuario, su sesión a vencido.");
              //   this.loadingScreenService.stopLoading();
              //   // this.global.signOff();
              //   this.router.navigate(['/home'])
              // }
              // else{
              //   if ((parseInt(subscriber.length) - 1) === index) {
              //     this.offers.push(JSON.parse(this.offersData(data, type, 3)));
              //     this.loadOffers(this.offers);
              //   }
              //   else {
              //     this.offers.push(JSON.parse(this.offersData(data, type, 3)));
              //     this.getOffers(subscriber, parseInt(index + 1));
              //   }
              // }
            }
          },
          (error) => {
            this.loadingScreenService.stopLoading();
            this.messageService.sentMessage("canceled", {
              method: "Error obteniendo planes",
            });
            console.log(error);
          }
        );
    }
  }
  goChat() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
      this.global.irChat();
    }
  }

  validateBalanceWithPricePlan(i): boolean {
    return (
      Number(this.info[i].prepaidBalanceField) <
      this.info[i].planInfoField.socRateField
    );
  }

  stringToNumber(value) {
    if (typeof value === "string") {
      return Number(value);
    } else {
      return value;
    }
  }

  getValuetoRecharge(val1, val2) {
    if (typeof val1 === "string") {
      Number(val1);
    }
    if (typeof val2 === "string") {
      Number(val2);
    }
    const result = val1 - val2;
    const resultFixed = result.toFixed(2);

    return resultFixed.toString();
  }

  validatePaymentGreaterThanBalance(inf) {
    const currentBalance = this.stringToNumber(inf.prepaidBalanceField);
    return this.pricePlan > currentBalance;
  }
}
